import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import { Paper } from '@mui/material';

export const SidebarWrapper = styled(Grid)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    maxWidth: '28%',
    flexBasis: '28%',
    height: '100%'
  },
  [`${theme.breakpoints.down('sm')} and (orientation: landscape)`]: {
    paddingBottom: `${theme.spacing(3)} !important`
  }
}));

export const StepProgressPaper = styled(Paper)({
  padding: 0,
  height: '100%'
});
